module.exports = __webpack_public_path__ + "static/media/riskVascularDisease.06b31e81.mp3";